export const _DEFAULT_TAGS =  {
    'kick': 'kick',
    'hi-hat': 'hi-hat',
    'snare': 'snare',
    'clap': 'clap',
    'rim': 'rim',
    'tom': 'tom',
    'perc': 'perc',
    'breaks': 'breaks',
    'bass': 'bass',
    'sub': [['808', 'sub']],
    'keys': 'keys',
    'breaks': 'breaks',
};

export const DEFAULT_TAGS =  {
    'kick': 'kick',
    'hi-hat': 'hi-hat',
    'snare': 'snare',
    'clap': 'clap',
    'rim': 'rim',
    'tom': 'tom',
    'perc': 'perc',
    'sub': [['808', 'sub']],
    'breaks': 'breaks',
    //'keys': 'keys',
};

export const COMMON_TAGS =  [
    'kick',
    'hi-hat',
    'snare',
    'clap',
    'rim',
    'tom',
    'perc',
    'sub',
    'breaks',
    'keys',
    '808',
    'synth',
    'vocal',
    'vox',
    'bass',
    'pluck',
    'chord',
    'fx',
];



